<template>
  <b-modal
    header-close-content=""
    body-class="view-options-modal"
    id="view-options-modal"
    :title="$t('menubar.view')"
    data-cy="editor-view-option-modal"
    ok-only>
    <div class="section-wrapper">
      <div class="settings-group">
        <div class="settings-group-title">{{ $t("general") }}</div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsCatalogNodeStatusVisible" switch data-cy="editor-node-status-cbx">{{
            $t("menubar.options.showCatalogueGroupStatus")
          }}</b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsUidVisible" switch data-cy="editor-node-uid-cbx">{{ $t("showCatalogNodeAndAttributeUids") }}</b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsAlternativeNameVisible" switch data-cy="editor-alternative-name-cbx">{{
            $t("showAlternativeNames")
          }}</b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsAbbreviationVisible" switch data-cy="editor-abbreviation-cbx">{{ $t("showAbbrevations") }}</b-form-checkbox>
        </div>
      </div>
      <div class="settings-group">
        <div class="settings-group-title">{{ $t("hints") }}</div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsFallbackHintVisible" switch data-cy="editor-fallback-hint-cbx">{{
            $t("ShowFallbackLanguageHint")
          }}</b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsInheritanceIndicatorVisible" switch data-cy="editor-abbreviation-cbx">{{
            $t("ShowInheritanceIndicator")
          }}</b-form-checkbox>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      checked: true,
      settings: {
        IsUidVisible: false,
        IsAlternativeNameVisible: false,
        IsAbbreviationVisible: false,
        IsFallbackHintVisible: false,
        IsCatalogNodeStatusVisible: false,
        IsInheritanceIndicatorVisible: false
      }
    };
  },
  computed: {
    ...mapState(["userSettings"])
  },
  methods: {
    ...mapActions(["saveUserSettings"])
  },
  watch: {
    settings: {
      deep: true,
      handler(nv) {
        this.saveUserSettings(nv);
      }
    },
    userSettings: {
      immediate: true,
      deep: true,
      handler(nv) {
        if (!nv) return;

        Object.assign(this.settings, {
          IsUidVisible: nv.IsUidVisible === true || nv.IsUidVisible === "true",
          IsAbbreviationVisible: nv.IsAbbreviationVisible === true || nv.IsAbbreviationVisible === "true",
          IsAlternativeNameVisible: nv.IsAlternativeNameVisible === true || nv.IsAlternativeNameVisible === "true",
          IsFallbackHintVisible: nv.IsFallbackHintVisible === true || nv.IsFallbackHintVisible === "true" || nv.IsFallbackHintVisible === undefined,
          IsCatalogNodeStatusVisible: nv.IsCatalogNodeStatusVisible === true || nv.IsCatalogNodeStatusVisible === "true",
          IsInheritanceIndicatorVisible: nv.IsInheritanceIndicatorVisible === true || nv.IsInheritanceIndicatorVisible === "true"
        });
      }
    }
  }
};
</script>
